var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var recyclableRender = false
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"async-loading"},[_c('p',[_vm._v("加载中...")])])}]

export { render, staticRenderFns, recyclableRender, components }